import type { ProjectResource } from "@octopusdeploy/octopus-server-client";
import React from "react";
import { EditDeploymentFreeze } from "~/components/DeploymentFreezes/EditDeploymentFreeze";
interface EditProjectDeploymentFreezePageProps {
    deploymentFreezeId: string;
    project: ProjectResource;
    spaceId: string;
}
export function EditProjectDeploymentFreezePage({ deploymentFreezeId, project }: EditProjectDeploymentFreezePageProps) {
    return <EditDeploymentFreeze create={false} deploymentFreezeId={deploymentFreezeId} project={project}/>;
}
